var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.getDrawerText(_vm.shift)))]),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.getStartedAtText(_vm.shift)))]),(!_vm.isDrawerOpen(_vm.shift))?[_c('small',{staticClass:"text-muted"},[_vm._v(" | "+_vm._s(_vm.getEndedAtText(_vm.shift)))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }